export const CARD_VIEW = 'card';
export const LIST_VIEW = 'list';
